import { getEnglishIqScorePosition } from './get-english-iq-score-position';

interface IEnglishIqScoreGaugeProps {
  cefr: string;
  score: number;
}

const RADIUS = 88;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
const SWEEP = 0.75;

export function EnglishIqScoreGauge({ cefr, score }: IEnglishIqScoreGaugeProps): React.JSX.Element {
  const { maxScore, minScore, progress } = getEnglishIqScorePosition(score);
  const track = CIRCUMFERENCE * SWEEP;
  const filled = track * (progress / 100);

  return (
    <div className="relative mx-auto mt-2 grid w-full max-w-[17rem] place-items-center">
      <svg
        aria-hidden="true"
        className="w-full -rotate-[225deg]"
        viewBox="0 0 200 200"
        role="presentation"
      >
        <circle
          className="text-foreground/10"
          cx="100"
          cy="100"
          fill="none"
          r={RADIUS}
          stroke="currentColor"
          strokeDasharray={`${track} ${CIRCUMFERENCE}`}
          strokeLinecap="round"
          strokeWidth="12"
        />
        <defs>
          <linearGradient id="english-iq-gauge" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#7c3aed" />
            <stop offset="55%" stopColor="#d946ef" />
            <stop offset="100%" stopColor="#06b6d4" />
          </linearGradient>
        </defs>
        <circle
          cx="100"
          cy="100"
          fill="none"
          r={RADIUS}
          stroke="url(#english-iq-gauge)"
          strokeDasharray={`${filled} ${CIRCUMFERENCE}`}
          strokeLinecap="round"
          strokeWidth="12"
        />
      </svg>
      <div className="absolute grid place-items-center">
        <span className="bg-gradient-to-r from-violet-600 via-fuchsia-500 to-cyan-500 bg-clip-text text-7xl font-black tracking-[-0.06em] text-transparent">
          {score}
        </span>
        <span className="mt-1 text-sm font-semibold text-muted-foreground">{cefr}</span>
      </div>
      <div className="mt-1 flex w-full max-w-[13rem] justify-between text-xs font-medium text-muted-foreground">
        <span>{minScore}</span>
        <span>{maxScore}</span>
      </div>
    </div>
  );
}
